/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessageCircle: {
  name: 'bubble-message-circle';
  data: string;
} = {
  name: 'bubble-message-circle',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.5a6.5 6.5 0 0 0-5.875 9.286.5.5 0 0 1 .042.297L1.61 14.39l3.307-.557a.5.5 0 0 1 .298.042A6.5 6.5 0 1 0 8 1.5ZM.5 8a7.5 7.5 0 1 1 4.43 6.845l-3.847.648a.5.5 0 0 1-.576-.576l.648-3.848A7.475 7.475 0 0 1 .5 8ZM8 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM4 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>`,
};
